/**
 * Localized label for product unit_type from DB/API (product_unit_type enum).
 * Also handles client-side alias "weight" used in inventory UI (same as kg).
 */
export function formatProductUnitType(unitType, t) {
  const u = String(unitType || 'piece').toLowerCase();
  if (u === 'kg' || u === 'weight') return t('pos.kg');
  if (u === 'piece' || u === 'pc' || u === 'pcs') return t('pos.pcs');
  return unitType || '';
}
